/**
 * modificationMass_UserSelections_DisplayMassSelectionOverlay.ts
 * 
 * Variable or Open Modification Mass Selection - Overlay for Large number of Modification masses
 * 
 * Re-uses Selection from Project Search based code for Large number of Modification masses
 *
 */

//   Modification Mass Rounding to provide some level of commonality between searches
import {modificationMass_CommonRounding_ReturnNumber_Function} from 'page_js/data_pages/modification_mass_common/modification_mass_rounding';

import {ModificationMass_Subpart_Variable_Open_Modifications_UserSelections_StateObject} from './modificationMass_Subpart_Variable_Open_Modifications_UserSelections_StateObject';
import {
    get_ModificationMass_UserSelections_DisplayMassSelectionOverlay_Layout,
    ModificationMass_UserSelections_DisplayMassSelectionOverlay__Variable_Or_Open_Mods,
    ModificationMass_UserSelections_DisplayMassSelectionOverlay_OuterContainer_Component__Callback_updateSelectedMods,
    ModificationMass_UserSelections_DisplayMassSelectionOverlay_OuterContainer_Component__Callback_updateSelectedMods_Params
} from "page_js/data_pages/common_filtering_code_filtering_components__except_mod_main_page/filter_on__components/filter_on__core__components__peptide__single_protein/filter_on__modification__reporter_ion/modification_mass_user_selections/jsx/modificationMass_UserSelections_DisplayMassSelectionOverlay_Layout";
import {
    limelight_add_ReactComponent_JSX_Element_To_DocumentBody,
    Limelight_ReactComponent_JSX_Element_AddedTo_DocumentBody_Holder_IF
} from "page_js/common_all_pages/limelight_add_ReactComponent_JSX_Element_To_DocumentBody";
import {SingleProtein_Filter_SelectionType} from "page_js/data_pages/project_search_ids_driven_pages/protein_page/protein_page_single_protein_common/proteinPage_SingleProtein_Filter_Enums";
import {CommonData_LoadedFromServer_PerSearch_Plus_SomeAssocCommonData__Except_ModMainPage__Root} from "page_js/data_pages/common_data_loaded_from_server__per_search_plus_some_assoc_common_data__with_loading_code__except_mod_main_page/commonData_LoadedFromServer_PerSearch_Plus_SomeAssocCommonData__Except_ModMainPage__Root";

//  Modal Dialog for selecting mod masses when count > _MAX_MODS_DISPLAY_NON_SELECTED

/**
 *
 */
export class ModificationMass_UserSelections_DisplayMassSelectionOverlay {

    //  Exactly 1 of following has to be true
    private _variable_Modifications_DISPLAY : boolean
    private _open_Modifications_DISPLAY : boolean

    private _remove_ModalOverlay_BindThis = this._remove_ModalOverlay.bind(this);
    private _updateSelectedMods_BindThis = this._updateSelectedMods.bind(this);

    private _DO_NOT_CALL() {
        const updateSelectedMods : ModificationMass_UserSelections_DisplayMassSelectionOverlay_OuterContainer_Component__Callback_updateSelectedMods = this._updateSelectedMods
    }

    private _proteinNames : string  //  Not populated on Peptide page
    private _proteinDescriptions : string  //  Not populated on Peptide page

    private _modificationSelectionChanged_Callback : () => void;

    private _modificationMass_Subpart_Variable_Open_Modifications_UserSelections_StateObject : ModificationMass_Subpart_Variable_Open_Modifications_UserSelections_StateObject;
    private _proteinSequenceVersionId : number  //  Not populated on Peptide page
    private _projectSearchIds : Array<number> 
    private _commonData_LoadedFromServer_PerSearch_Plus_SomeAssocCommonData__Except_ModMainPage__Root : CommonData_LoadedFromServer_PerSearch_Plus_SomeAssocCommonData__Except_ModMainPage__Root
    private _modificationMass_CommonRounding_ReturnNumber : modificationMass_CommonRounding_ReturnNumber_Function // Always passed for Experiment - Made a parameter to make easier to copy this code for Protein Page Single Search

    private _modMassOverlay_AddedTo_DocumentBody_Holder : Limelight_ReactComponent_JSX_Element_AddedTo_DocumentBody_Holder_IF;

	/**
	 * 
	 */
	constructor(
	    {
            variable_Modifications_DISPLAY,
            open_Modifications_DISPLAY,
            modificationMass_Subpart_Variable_Open_Modifications_UserSelections_StateObject,
            proteinNames,  //  Not populated on Peptide page
            proteinDescriptions,  //  Not populated on Peptide page
            proteinSequenceVersionId,  //  Not populated on Peptide page
            projectSearchIds,
            commonData_LoadedFromServer_PerSearch_Plus_SomeAssocCommonData__Except_ModMainPage__Root,
            modificationMass_CommonRounding_ReturnNumber,
            modificationSelectionChanged_Callback
        } : {
            variable_Modifications_DISPLAY : boolean
            open_Modifications_DISPLAY : boolean
            modificationMass_Subpart_Variable_Open_Modifications_UserSelections_StateObject : ModificationMass_Subpart_Variable_Open_Modifications_UserSelections_StateObject,
            proteinNames : string  //  Not populated on Peptide page
            proteinDescriptions : string  //  Not populated on Peptide page
            proteinSequenceVersionId : number,  //  Not populated on Peptide page
            projectSearchIds : Array<number>,
            commonData_LoadedFromServer_PerSearch_Plus_SomeAssocCommonData__Except_ModMainPage__Root : CommonData_LoadedFromServer_PerSearch_Plus_SomeAssocCommonData__Except_ModMainPage__Root
            modificationMass_CommonRounding_ReturnNumber : modificationMass_CommonRounding_ReturnNumber_Function // Always passed for Experiment - Made a parameter to make easier to copy this code for Protein Page Single Search
            modificationSelectionChanged_Callback : () => void
        }) {

        if ( variable_Modifications_DISPLAY && open_Modifications_DISPLAY ) {
            const msg = "Cannot BOTH be true: variable_Modifications_DISPLAY && open_Modifications_DISPLAY"
            console.warn( msg )
            throw Error( msg )
        }
        if ( ( ! variable_Modifications_DISPLAY )  && ( ! open_Modifications_DISPLAY ) ) {
            const msg = "Cannot BOTH be false: variable_Modifications_DISPLAY && open_Modifications_DISPLAY"
            console.warn( msg )
            throw Error( msg )
        }
        if ( ! modificationSelectionChanged_Callback ) {
            const msg = "ModificationMass_UserSelections_DisplayMassSelectionOverlay: constructor: Invalid: modificationSelectionChanged_Callback not populated ";
            console.warn( msg );
            throw Error( msg );
        }
        this._variable_Modifications_DISPLAY = variable_Modifications_DISPLAY;
        this._open_Modifications_DISPLAY = open_Modifications_DISPLAY;

        this._modificationMass_Subpart_Variable_Open_Modifications_UserSelections_StateObject = modificationMass_Subpart_Variable_Open_Modifications_UserSelections_StateObject;

        this._proteinNames = proteinNames;
        this._proteinDescriptions = proteinDescriptions;
        this._modificationSelectionChanged_Callback = modificationSelectionChanged_Callback;

        this._proteinSequenceVersionId = proteinSequenceVersionId
        this._projectSearchIds = projectSearchIds
        this._commonData_LoadedFromServer_PerSearch_Plus_SomeAssocCommonData__Except_ModMainPage__Root = commonData_LoadedFromServer_PerSearch_Plus_SomeAssocCommonData__Except_ModMainPage__Root
        this._modificationMass_CommonRounding_ReturnNumber = modificationMass_CommonRounding_ReturnNumber;
    
    }

	/**
	 * Display Dialog for "Change Mods"
	 */
    showModificationMassSelectionDialog() : void {

        if ( this._variable_Modifications_DISPLAY ) {

            this._createAndShowModalOverlay( { variable_Or_Open_Mods: ModificationMass_UserSelections_DisplayMassSelectionOverlay__Variable_Or_Open_Mods.VARIABLE } );

        } else if ( this._open_Modifications_DISPLAY ) {

            this._createAndShowModalOverlay( { variable_Or_Open_Mods: ModificationMass_UserSelections_DisplayMassSelectionOverlay__Variable_Or_Open_Mods.OPEN } );

        } else {
            const msg = "Neither of these is true: this._variable_Modifications_DISPLAY, this._open_Modifications_DISPLAY "
            console.warn(msg)
            throw Error( msg )
        }
    }

    /**
     * Create and return the overlay, but don't show it
     * 
     * @param {*} param0 
     */
    _createAndShowModalOverlay( { variable_Or_Open_Mods }  : { variable_Or_Open_Mods : ModificationMass_UserSelections_DisplayMassSelectionOverlay__Variable_Or_Open_Mods } ) {

        const overlayComponent = get_ModificationMass_UserSelections_DisplayMassSelectionOverlay_Layout({
            variable_Or_Open_Mods,
            proteinName : this._proteinNames,
            proteinSequenceVersionId: this._proteinSequenceVersionId,  //  Not populated on Peptide page
            projectSearchIds: this._projectSearchIds,
            commonData_LoadedFromServer_PerSearch_Plus_SomeAssocCommonData__Except_ModMainPage__Root: this._commonData_LoadedFromServer_PerSearch_Plus_SomeAssocCommonData__Except_ModMainPage__Root,
            modificationMass_CommonRounding_ReturnNumber: this._modificationMass_CommonRounding_ReturnNumber,
            modificationMass_Subpart_Variable_Open_Modifications_UserSelections_StateObject : this._modificationMass_Subpart_Variable_Open_Modifications_UserSelections_StateObject,
            callbackOn_Cancel_Close_Clicked : this._remove_ModalOverlay_BindThis,
            callback_updateSelectedMods : this._updateSelectedMods_BindThis
        });

        this._modMassOverlay_AddedTo_DocumentBody_Holder = limelight_add_ReactComponent_JSX_Element_To_DocumentBody({ componentToAdd : overlayComponent })
    }

    ////////////////////////

    /**
     *
     */
    _remove_ModalOverlay() {

        this._modMassOverlay_AddedTo_DocumentBody_Holder.removeContents_AndContainer_FromDOM();

        this._modMassOverlay_AddedTo_DocumentBody_Holder.removeContents_AndContainer_FromDOM();

        this._modMassOverlay_AddedTo_DocumentBody_Holder = undefined;
    }

	/**
	 * 
	 */
    _updateSelectedMods( params : ModificationMass_UserSelections_DisplayMassSelectionOverlay_OuterContainer_Component__Callback_updateSelectedMods_Params ) {

        const updated_selectedModificationMasses_Map = params.updated_selectedModificationMasses_Map

        this._remove_ModalOverlay();

        //  Clear main mod mass selections
        this._modificationMass_Subpart_Variable_Open_Modifications_UserSelections_StateObject.clear_selectedModifications_ExceptUnmodified();

        //  Add in newly selected mod masses

        //  First add Type AND (Triggers processing in called code)

        let found_AND_Selection = false;

        for ( const mapEntry of updated_selectedModificationMasses_Map.entries() ) {
            const entryKey = mapEntry[ 0 ]
            const entryValue = mapEntry[ 1 ]
            if ( entryValue.selectionType === SingleProtein_Filter_SelectionType.ALL ) {
                this._modificationMass_Subpart_Variable_Open_Modifications_UserSelections_StateObject.set_Modification_Selected(entryKey, entryValue);
                found_AND_Selection = true;
            }
        }

        //  Second add Type other than AND (Triggers processing in called code)

        const skipChangeOtherSelectionsBasedOnThisSelection = found_AND_Selection;

        for ( const mapEntry of updated_selectedModificationMasses_Map.entries() ) {
            const entryKey = mapEntry[ 0 ]
            const entryValue = mapEntry[ 1 ]
            if ( entryValue.selectionType !== SingleProtein_Filter_SelectionType.ALL ) {
                this._modificationMass_Subpart_Variable_Open_Modifications_UserSelections_StateObject.set_Modification_Selected(entryKey, entryValue, skipChangeOtherSelectionsBasedOnThisSelection);
            }
        }

        this._modificationSelectionChanged_Callback();  //  Call function in object property _modificationSelectionChanged_Callback
    }

}